<template>
  <viewOrComment type="view" view />
</template>
<script setup lang="ts">
import viewOrComment from './components/viewOrComment.vue'
</script>
<script lang="ts">
export default { name: 'DcCosLbuSaleCoachingView' }
</script>
